import BackendService from './BackendService';

export default class DeskingService {
  static getDesking(dealId, carId) {
    return BackendService.get(`/desking/${dealId}/${carId}`);
  }

  static sendToSalesperson(deskingId) {
    return BackendService.post(`/desking/${deskingId}/sendToSalesperson`);
  }

  static createDeskingOffer(deskingOffer) {
    return BackendService.post(`/deskingOffer`, {
      body: deskingOffer,
    });
  }

  static createDefaultDeskingOffer(input) {
    return BackendService.post(`/deskingOffer/default`, {
      body: input,
    });
  }

  static bulkUpdateDeskingOffers(body) {
    return BackendService.put('/deskingOffer/bulk', { body });
  }

  static deleteDeskingOffer(deskingOfferId) {
    return BackendService.delete(`/deskingOffer/${deskingOfferId}`);
  }

  static pushDeskingOfferToCRM(deskingOfferId) {
    return BackendService.post(`/deskingOffer/${deskingOfferId}/push`);
  }

  static paymentRollback(body) {
    return BackendService.post('/deskingOffer/paymentRollback', { body });
  }

  static getOfferHistory(deskingOfferId) {
    return BackendService.get(`/deskingOffer/${deskingOfferId}/history`);
  }

  static getVersionSnapshots(deskingId, deskingOfferId, version) {
    return BackendService.get(
      `/desking/${deskingId}/history/${deskingOfferId}/${version}`,
    );
  }

  static createSticker(deskingId, body) {
    return BackendService.post(`/v2/workflow/desking/${deskingId}/sticker`, {
      body,
    });
  }

  static restoreVersion(deskingOfferId, version) {
    return BackendService.post(
      `/deskingOffer/${deskingOfferId}/restore/${version}`,
    );
  }
}
